import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchProperties } from "../lib/api";
import { PropertyCard } from "../components/PropertyCard";
import { getFavorites } from "../lib/favorites";
import { Heart } from "lucide-react";

export default function Favorites() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ids = getFavorites();
    if (!ids.length) { setItems([]); setLoading(false); return; }
    fetchProperties({ limit: 500 }).then((all) => {
      setItems(all.filter((p) => ids.includes(p.id)));
      setLoading(false);
    });
    const onChange = () => {
      const nids = getFavorites();
      setItems((prev) => prev.filter((p) => nids.includes(p.id)));
    };
    window.addEventListener("favorites-changed", onChange);
    return () => window.removeEventListener("favorites-changed", onChange);
  }, []);

  return (
    <div data-testid="favorites-page" className="pt-28 pb-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center gap-3 mb-3">
          <Heart className="w-5 h-5 text-[#C0562F]" />
          <div className="label-caps">Kaydedilenler</div>
        </div>
        <h1 className="font-display text-4xl sm:text-5xl text-slate-900 mb-8">Favorilerim</h1>

        {loading ? (
          <div className="text-slate-500">Yükleniyor…</div>
        ) : items.length === 0 ? (
          <div className="text-center py-24 bg-white border border-slate-200 rounded-2xl">
            <div className="font-display text-2xl text-slate-900 mb-2">Henüz favori ilanınız yok.</div>
            <p className="text-slate-500 mb-6">İlanları incelerken kalp ikonuna dokunarak buraya ekleyebilirsiniz.</p>
            <Link to="/ilanlar" data-testid="fav-browse" className="btn-primary px-6 py-3 rounded-full text-sm font-semibold">İlanları İncele</Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map((p, i) => <PropertyCard key={p.id} p={p} idx={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
